import { ActivatedRoute, Router } from '@angular/router';
import { Role } from '../../shared/models/role';
import { AuthService } from '../../login/services/auth.service';
import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { DacConfig } from '../../shared/services/dac-config.service';
import { Capability } from 'app/shared/models/capability';
var NavBarService = /** @class */ (function () {
    function NavBarService(authService, activatedRoute, router, dacConfig) {
        var _this = this;
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.dacConfig = dacConfig;
        this._userSubscription = this.authService.getLoginState().subscribe(function (stateUpdate) {
            _this.user = stateUpdate.user;
            _this._navItems = _this.createNavItems(); // update our navigation items.
            _this._topNavBarItems = _this.createTopNavItems();
        });
        // this._navItems = this.createNavItems();
        this._displaySideBarEvent = new Subject();
        this._navBarAction = new Subject();
        this._reportNavBarItems = [];
    }
    NavBarService.prototype.ngOnDestroy = function () {
        this._userSubscription.unsubscribe();
    };
    Object.defineProperty(NavBarService.prototype, "displaySideBarEvent", {
        get: function () {
            return this._displaySideBarEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavBarService.prototype, "navBarAction", {
        get: function () {
            return this._navBarAction;
        },
        enumerable: true,
        configurable: true
    });
    NavBarService.prototype.toggleSidebar = function () {
        // send off an event to show the sidebar.
        this.displaySideBarEvent.next();
    };
    NavBarService.prototype.setupReportSidebar = function (reportClientId) {
        var navItems = [];
        navItems.push(this.getHomeMenuItem());
        navItems.push({
            id: "clients",
            name: "Clients",
            routerLink: ['/', 'admin', 'clients'],
            role: [Role.Registered],
            roleExplicitMatch: false,
            hasChildren: false
        });
        navItems.push({
            id: "currentClient",
            name: 'Back to ' + reportClientId,
            routerLink: ['/', 'admin', 'client', reportClientId],
            role: [Role.Registered],
            roleExplicitMatch: false,
            hasChildren: false
        });
        this._reportNavBarItems = navItems;
    };
    NavBarService.prototype.clearReportSidebar = function () {
        this._reportNavBarItems = [];
    };
    NavBarService.prototype.addReportNavBarItem = function (id, name) {
        this._reportNavBarItems.push({
            id: id,
            name: name,
            routerLink: null,
            role: [Role.Registered],
            roleExplicitMatch: false,
            hasChildren: false,
            type: 'report-item'
        });
    };
    NavBarService.prototype.handleMenuItemClick = function (navItem, event) {
        var _this = this;
        if (navItem.id == 'logout') {
            event.preventDefault();
            event.stopPropagation();
            this.authService.logout().then(function (resp) {
                if (resp.redirectUrl) {
                    window.location.href = resp.redirectUrl;
                }
                else {
                    _this.router.navigate(['/home']);
                }
            })
                .catch(function (error) {
                console.error(error);
                _this.router.navigate(["/home"]);
            });
            return;
        }
        this._navBarAction.next(navItem);
        if (navItem.type && navItem.type == 'report-item') {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    Object.defineProperty(NavBarService.prototype, "topNavBarItemsForDisplay", {
        get: function () {
            var _this = this;
            var items = this._topNavBarItems;
            // any item with children... filter out the children based upon the display
            items.filter(function (i) { return i.children; })
                .forEach(function (i) {
                i.children = i.children.filter(function (ic) { return _this.shouldDisplayItem(ic); });
                i.hasChildren = i.children.length > 0;
            });
            // now filter out the parents.
            return items.filter(function (ni) { return _this.shouldDisplayItem(ni); });
        },
        enumerable: true,
        configurable: true
    });
    NavBarService.prototype.createTopNavItems = function () {
        var navItems = [
            this.getClientLoginMenuItem(),
            this.getAdminLoginMenuItem(),
            this.getClientDashboardMenuItem()
        ];
        navItems.push({
            id: "help",
            name: "Contact",
            routerLink: ['/help'],
            role: [],
            roleExplicitMatch: false,
            hasChildren: false
        });
        navItems.push(this.getMyAccountMenuItem());
        navItems.push(this.getLogoutMenuItem());
        return navItems;
    };
    NavBarService.prototype.createNavItems = function () {
        var navItems = [];
        navItems.push(this.getHomeMenuItem());
        navItems.push(this.getClientLoginMenuItem());
        navItems.push(this.getAdminLoginMenuItem());
        navItems.push(this.getClientDashboardMenuItem());
        navItems.push({
            id: "systemOverview",
            name: "System Overview",
            routerLink: ['/', 'admin', 'system'],
            role: [Role.SuperUser],
            roleExplicitMatch: true,
            hasChildren: false
        });
        navItems.push({
            id: "companies",
            name: "Companies",
            routerLink: ['/', 'admin', 'companies'],
            role: [Role.SuperUser],
            roleExplicitMatch: true,
            hasChildren: false
        });
        navItems.push({
            id: "users",
            name: "Users",
            routerLink: ['/', 'admin', 'users'],
            role: [Role.Admin],
            roleExplicitMatch: false,
            hasChildren: false
        });
        navItems.push({
            id: "clients",
            name: "Clients",
            routerLink: ['/', 'admin', 'clients'],
            role: [Role.Registered],
            roleExplicitMatch: false,
            hasChildren: false
        });
        var assessments = {
            id: "adminAssessments",
            name: "Assessments",
            role: [Role.Registered],
            roleExplicitMatch: false,
            children: [],
            hasChildren: true
        };
        assessments.children.push({
            id: "manageAssessments",
            name: "Assessments",
            role: [Role.Registered],
            roleExplicitMatch: false,
            routerLink: ['/', 'admin', 'assessment', 'manage'],
            hasChildren: false
        });
        assessments.children.push({
            id: "manageBatteries",
            name: "Batteries",
            role: [Role.Registered],
            roleExplicitMatch: false,
            routerLink: ['/', 'admin', 'assessment', 'batteries'],
            hasChildren: false
        });
        if (this.dacConfig.isFeatureEnabled('assessments.reports.manage')) {
            assessments.children.push({
                id: "manageAssessmentReports",
                name: "Reports",
                role: [Role.SuperUser],
                roleExplicitMatch: false,
                routerLink: ['/', 'admin', 'assessment', 'custom-reports'],
                hasChildren: false
            });
        }
        navItems.push(assessments);
        var library = {
            id: "adminLibrary",
            name: "Homework Library",
            role: [Role.Registered],
            roleExplicitMatch: false,
            children: [],
            hasChildren: true
        };
        library.children.push({
            id: "libraryArticles",
            name: "Articles",
            role: [Role.Registered],
            roleExplicitMatch: false,
            children: [],
            hasChildren: false,
            routerLink: ['/', 'admin', 'library', 'articles']
        });
        library.children.push({
            id: "libraryExercises",
            name: "Exercises",
            role: [Role.Registered],
            roleExplicitMatch: false,
            children: [],
            hasChildren: false,
            routerLink: ['/', 'admin', 'library', 'exercises']
        });
        navItems.push(library);
        navItems.push({
            id: "shop",
            name: "Shop",
            routerLink: ['/', 'admin', 'shop'],
            role: [],
            capability: [Capability.CAN_SHOP],
            roleExplicitMatch: false,
            hasChildren: false
        });
        navItems.push(this.getMyAccountMenuItem());
        navItems.push(this.getLogoutMenuItem());
        return navItems;
    };
    NavBarService.prototype.getClientDashboardMenuItem = function () {
        return {
            id: "clientDashboard",
            name: "Dashboard",
            routerLink: ['/', 'assessments', 'dashboard'],
            role: [Role.Client],
            roleExplicitMatch: true,
            hasChildren: false
        };
    };
    NavBarService.prototype.getHomeMenuItem = function () {
        return {
            id: "home",
            name: "Home",
            routerLink: ['/'],
            role: [Role.UnAuthenticated],
            roleExplicitMatch: false,
            hasChildren: false
        };
    };
    NavBarService.prototype.getClientLoginMenuItem = function () {
        return {
            id: "clientLogin",
            name: "Client Login",
            routerLink: ['/login'],
            role: [Role.UnAuthenticated],
            roleExplicitMatch: true,
            hasChildren: false
        };
    };
    NavBarService.prototype.getAdminLoginMenuItem = function () {
        return {
            id: "adminLogin",
            name: "Therapist Login",
            routerLink: ['/loginAdmin/'],
            role: [Role.UnAuthenticated],
            roleExplicitMatch: true,
            hasChildren: false
        };
    };
    NavBarService.prototype.getLogoutMenuItem = function () {
        return {
            id: "logout",
            name: "Logout",
            routerLink: null // no link as we don't want to go to a logout right now.
            ,
            role: [Role.Client],
            roleExplicitMatch: false,
            hasChildren: false
        };
    };
    NavBarService.prototype.getMyAccountMenuItem = function () {
        return {
            id: "adminMyAccount",
            name: "My Account",
            routerLink: ['/', 'admin', 'my-account'],
            role: [Role.Registered],
            roleExplicitMatch: false,
            hasChildren: false
        };
    };
    NavBarService.prototype.shouldDisplayItem = function (navItem) {
        var _this = this;
        if (navItem.capability && navItem.capability.length) {
            return navItem.capability.some(function (c) { return _this.user.hasCapability(c); });
        }
        if (navItem.role.length) {
            if (navItem.roleExplicitMatch) {
                return navItem.role.some(function (r) { return _this.user.role === r; });
            }
            else {
                return navItem.role.some(function (r) { return _this.user.role <= r; });
            }
        }
        return true;
    };
    Object.defineProperty(NavBarService.prototype, "navItemsForDisplay", {
        get: function () {
            var _this = this;
            var items = this.navItems;
            if (this._reportNavBarItems.length) {
                items = this._reportNavBarItems;
            }
            // any item with children... filter out the children based upon the display
            items.filter(function (i) { return i.children; })
                .forEach(function (i) {
                i.children = i.children.filter(function (ic) { return _this.shouldDisplayItem(ic); });
                i.hasChildren = i.children.length > 0;
            });
            // now filter out the parents.
            return items.filter(function (ni) { return _this.shouldDisplayItem(ni); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavBarService.prototype, "navItems", {
        get: function () {
            return this._navItems;
        },
        enumerable: true,
        configurable: true
    });
    return NavBarService;
}());
export { NavBarService };



// WEBPACK FOOTER //
// ./src/app/theme/services/nav-bar.service.ts.pre-build-optimizer.js